var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isBrowser, isTst1 } from '../lib/environment';
import { log } from '../lib/logger';
import { captureException } from '../lib/sentry';
import { showChatBoxParamName } from '../constants/locationParams';
import { O } from '../lib/EffectExports';
import { createAuth } from '@spotify-internal/oauth-silent-authentication';
const authServerConfigForStaging = {
    url: 'https://accounts-shared.spotify.net',
};
const getAuthClient = (clientId, scopes) => {
    return createAuth({ clientId, scopes: scopes }, isTst1 ? authServerConfigForStaging : undefined);
};
export const getToken = (clientId, scopes = []) => __awaiter(void 0, void 0, void 0, function* () {
    if (!isBrowser)
        return new Promise(() => { });
    try {
        const [token] = yield getAuthClient(clientId, scopes).tokenProvider();
        return O.some(token);
    }
    catch (e) {
        log.error('There was an error on login', e);
        if (e.error !== 'login_required' && e.error !== 'timeout') {
            captureException(e);
            throw e;
        }
        return O.none();
    }
});
export const login = (clientId, redirectUri) => {
    if (!isBrowser)
        return;
    getAuthClient(clientId, []).login({
        redirectUri,
        state: showChatBoxParamName,
    });
};
//# sourceMappingURL=authentication.js.map